export const DAO_CODE = 'ACTIVITIES' + '_DAO';
